// ====================
// 375px以下でviewportを固定にする
// ====================

function viewport() {
  const viewport = document.querySelector('meta[name="viewport"]');
  const isHome = document.body.classList.contains('home');

  // Function to switch viewport content based on media queries
  function switchViewport() {
    const width = window.innerWidth;
    
    if (isHome) {
      if (width <= 375) {
        viewport.content = "width=375, initial-scale=1";
      } else if (width <= 767) {
        viewport.content = "width=device-width, initial-scale=1";
      } else if (width <= 1450) {
        viewport.content = "width=1450, initial-scale=1";
      } else {
        viewport.content = "width=device-width, initial-scale=1";
      }
    } else {
      if (width <= 375) {
        viewport.content = "width=375, initial-scale=1";
      } else {
        viewport.content = "width=device-width, initial-scale=1";
      }
    }
  }

  // Initial call
  switchViewport();

  // Add event listener for window resize to update viewport dynamically
  window.addEventListener('resize', switchViewport);
}

// Initialize the viewport function
viewport();

export { viewport };
